import { PaymentType } from 'constants/PaymentType';
import { FormInput, FormInputProps } from 'modules';
import React from 'react';

const PaymentMethodSelect = (props: FormInputProps) => {
  const options = [
    {
      label: 'Prevodom na účet',
      value: PaymentType.TransferToAccount,
    },
    {
      label: 'Vkladom na účet',
      value: PaymentType.InsertToAccount,
    },
  ];

  return <FormInput {...props} type={'select'} options={options} />;
};

export default PaymentMethodSelect;
